import store from '../store/store'
import axios from 'axios'

export default {
  async getNonce () {
    const url = 'auth/nonce'
    const { data } = await axios.post(url)
    let nonce = null
    if (!data.error) {
      nonce = data.nonce
    }
    return nonce
  },
  getUserData (params) {
    const user = params.user
    const userData = {
      id: user.id,
      name: user.full_name,
      picture: user.picture,
      email: user.email,
      tel: user.tel,
      isPhoneVerified: (user.tel !== '' && user.tel !== null && user.tel_verified === 1),
      totalCredits: params.total_credits,
      pendingCredits: params.pending_credits,
      totalPoints: params.total_points,
      pointsExpireDate: params.points_expire_date,
      status: user.status,
      lineUserId: user.line_user_id,
      flagBlack: user.flag_black,
      platform: (user.platform) ? user.platform : null
    }
    return userData
  },
  setLoginData (params) {
    const user = params.user
    const userData = this.getUserData(params)
    store.commit('auth/SET_USER', userData)
    store.commit('auth/SET_TOKEN', user.token)
  },
  setLoginDataProfessional (params) {
    const professional = params.professional
    const token = params.token
    const tokenTemporary = params.token_temporary
    store.commit('auth/SET_PROFESSIONAL', professional)
    store.commit('auth/SET_TOKEN_PROFESSIONAL', token)
    store.commit('auth/SET_TOKEN_TEMP', tokenTemporary)
  }
}



// WEBPACK FOOTER //
// ./src/helpers/loginHelpers.js